import PropTypes from 'prop-types'
import styled from 'styled-components'
import { pixelise } from 'tools/style'

const Iframe = styled.iframe`
  ${props => props.width ? `width: ${pixelise(props.width)};` : ''}
  ${props => props.height ? `height: ${pixelise(props.height)};` : ''}
  ${props => props.allow ? `allow: ${props.allow};` : ''}
  ${props => props.allowFullscreen ? `allowfullscreen: ${props.allowFullscreen};` : ''}
  ${props => props.allowPaymentRequest ? `allowpaymentrequest: ${props.allowPaymentRequest};` : ''}
  ${props => props.name ? `name: ${props.name};` : ''}
  ${props => props.referrerPolicy ? `referrerpolicy: ${props.referrerPolicy};` : ''}
  ${props => props.sandbox ? `sandbox: ${props.sandbox};` : ''}
  ${props => props.src ? `src: ${props.src};` : ''}
  ${props => props.srcDoc ? `srcdoc: ${props.srcDoc};` : ''}
  ${props => props.frameBorder ? `frameBorder: ${props.frameBorder};` : ''}
`
Iframe.propTypes = {
  width: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  height: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  allow: PropTypes.any,
  allowFullscreen: PropTypes.bool,
  allowPaymentRequest: PropTypes.bool,
  name: PropTypes.string,
  referrerPolicy: PropTypes.string,
  sandbox: PropTypes.string,
  src: PropTypes.string,
  srcDoc: PropTypes.string,
  frameBorder: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ])
}

export default Iframe
